import { useEffect } from 'react'
import LookerTopFourLabel from '../../components/child/LookerTopFourLabel'
import LookerTopFourSong from '../../components/child/LookerTopFourSong'
import LookerTopFourArtist from '../../components/child/LookerTopFourArtist'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../context/AuthContext'
import LookerStatistics from '../../components/child/LookerStatistics'


const OverviewReport = () => {
    const navigate = useNavigate();
    const { email, roleCode } = useAuth();

  useEffect(() => {
  
    if (!email) {
      navigate('/login');
      return;
    }

  }, [navigate]);

  return (
      <>
          <div className="row gy-4">
              <div className="col-xxl-8">
                  <div className="row gy-4">
                      <LookerTopFourSong />
                      <LookerTopFourArtist />
                      {(roleCode === 'RL2411065833191' || roleCode === 'RL2411062373407') && (
                        <LookerTopFourLabel />
                      )}
                  </div>
              </div>

              <div className="col-xxl-4">
                  <div className="row gy-4">
                      <LookerStatistics />
                  </div>
              </div>
          </div>
      </>
  );
};

export default OverviewReport